import IntercomService from '../services/IntercomService.js'
import PropertyService from '../services/PropertyService.js'
import ServerService from '../services/ServerService.js'
import ContactService from '../services/ContactService.js'
import ContactPanelService from '../services/ContactPanelService.js'
import PanelService from '../services/PanelService.js'
import EnvironmentService from '../services/EnvironmentService.js'

export default {
  data() {
    return {
      intercomService: IntercomService,
      propertyService: PropertyService,
      serverService: ServerService,
      contactService: ContactService,
      contactPanelService: ContactPanelService,
      panelService: PanelService,
      environmentService: EnvironmentService,
    }
  },
  methods: {
    async getEnvironment() {
      if (this.$store.getters.environment) return

      await this.environmentService
        .getEnvironment()
        .then(response => {
          if (response.data && response.data.environment) {
            this.$store.dispatch('setEnvironment', response.data.environment)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getIntercoms(filters = {}) {
      await this.intercomService
        .getIntercoms(filters)
        .then(response => {
          if (response.meta) {
            this.$store.dispatch('setIntercomsMeta', response.meta)
          }

          if (response.data) {
            this.$store.dispatch('setIntercoms', response.data)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getProperties(filters = {}) {
      await this.propertyService
        .getProperties(filters)
        .then(response => {
          if (response.data) {
            this.$store.dispatch('setProperties', response.data)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPropertiesWithContacts(string = null) {
      this.propertyService
        .getPropertiesWithContacts(string)
        .then(response => {
          if (response.data) {
            this.$store.dispatch('setPropertiesWithContacts', response.data)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getServers(filters = {}) {
      await this.serverService
        .getServers(filters)
        .then(response => {
          if (response.meta) {
            this.$store.dispatch('setServersMeta', response.meta)
          }

          if (response.data) {
            this.$store.dispatch('setServers', response.data || [])
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getServerHealthCheck(suid) {
      if (!suid) return

      await this.serverService
        .getHealthCheck(suid)
        .then(response => {
          if (response.data) {
            this.$store.dispatch('setServerHealthCheck', {
              suid,
              data: response.data,
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getContactsByOrganization(
      organizationId,
      propertyId = null,
      sipServerId = null
    ) {
      this.contactService
        .getContactsByOrganization(organizationId, propertyId, sipServerId)
        .then(response => {
          this.$store.dispatch('setContacts', response.data || [])
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.$store.dispatch('setNotification', {
              text: error.response.data.message || 'Error',
            })
          }
        })
    },
    getContacts(filters = {}) {
      return new Promise((resolve, reject) => {
        this.contactService
          .getContacts(filters)
          .then(response => {
            this.$store.dispatch(
              'setContactsMeta',
              response.data ? response.data : {}
            )
            this.$store.dispatch(
              'setContacts',
              response.data && response.data.data ? response.data.data : []
            )

            resolve(response)
          })
          .catch(error => {
            if (error.response && error.response.data) {
              this.$store.dispatch('setNotification', {
                text: error.response.data.message || 'Error',
              })
            }

            resolve(error)
          })
      })
    },
    getPanels(cuid, filters = {}) {
      return new Promise((resolve, reject) => {
        this.panelService
          .getPanels(cuid, filters)
          .then(response => {
            // Update store with panels data
            this.$store.dispatch('setPanels', response.data || [])

            // Update metadata
            if (response.meta) {
              // Store pagination meta
              const paginationMeta = {
                current_page: response.meta.current_page,
                per_page: response.meta.per_page,
                total: response.meta.total,
              }
              this.$store.dispatch('setPanelsMeta', paginationMeta)

              // Store manufacturers if available
              if (response.meta.manufacturers) {
                this.$store.dispatch(
                  'setManufacturers',
                  response.meta.manufacturers
                )
              }

              // Store controlled device types if available
              if (response.meta.controlled_device_types) {
                this.$store.dispatch(
                  'setControlledDeviceTypes',
                  response.meta.controlled_device_types
                )
              }

              // Store lock types if available
              if (response.meta.lock_types) {
                this.$store.dispatch('setLockTypes', response.meta.lock_types)
              } else {
                const lockTypes = {
                  1: 'Основной',
                  2: 'Вспомогательный',
                }

                this.$store.dispatch('setLockTypes', lockTypes)
              }

              // Store available sections if available
              if (response.meta.available_sections) {
                this.$store.dispatch(
                  'setAvailableSections',
                  response.meta.available_sections
                )
              }
            }

            resolve(response)
          })
          .catch(error => {
            const errorMessage =
              error.response?.data?.message ||
              error.response?.data?.data?.error ||
              'Ошибка при загрузке панели'

            this.$store.dispatch('setNotification', {
              type: 'cross-outlined',
              text: errorMessage,
            })
            reject(error)
          })
      })
    },
    createPanel(cuid, panelData) {
      return new Promise((resolve, reject) => {
        this.panelService
          .createPanel(cuid, panelData)
          .then(response => {
            this.$store.dispatch('setNotification', {
              text: 'Панель успешно создана',
            })
            resolve(response)
          })
          .catch(error => {
            let errorMessage = 'Ошибка при создании панели'

            if (error.response?.data) {
              // Check if it's a validation error object
              if (
                typeof error.response.data === 'object' &&
                !error.response.data.message
              ) {
                // Format validation errors
                const errors = []
                Object.keys(error.response.data).forEach(field => {
                  const fieldErrors = error.response.data[field]
                  if (Array.isArray(fieldErrors)) {
                    errors.push(...fieldErrors)
                  }
                })
                errorMessage = errorMessage =
                  errors?.length > 0
                    ? errors.join('<br />')
                    : error.response.data.message ||
                      error.response.data.data?.error ||
                      errorMessage
              } else {
                // Use standard error message
                errorMessage =
                  error.response.data.message ||
                  error.response.data.data?.error ||
                  errorMessage
              }
            }

            this.$store.dispatch('setNotification', {
              type: 'cross-outlined',
              text: errorMessage,
            })
            reject(error)
          })
      })
    },
    updatePanel(cuid, panelId, panelData) {
      return new Promise((resolve, reject) => {
        this.panelService
          .updatePanel(cuid, panelId, panelData)
          .then(response => {
            this.$store.dispatch('setNotification', {
              text: 'Панель успешно обновлена',
            })
            resolve(response)
          })
          .catch(error => {
            let errorMessage = 'Ошибка при обновлении панели'

            if (error.response?.data) {
              // Check if it's a validation error object
              if (
                typeof error.response.data === 'object' &&
                !error.response.data.message
              ) {
                // Format validation errors
                const errors = []
                Object.keys(error.response.data).forEach(field => {
                  const fieldErrors = error.response.data[field]
                  if (Array.isArray(fieldErrors)) {
                    errors.push(...fieldErrors)
                  }
                })
                errorMessage =
                  errors?.length > 0
                    ? errors.join('<br />')
                    : error.response.data.message ||
                      error.response.data.data?.error ||
                      errorMessage
              } else {
                // Use standard error message
                errorMessage =
                  error.response.data.message ||
                  error.response.data.data?.error ||
                  errorMessage
              }
            }
            this.$store.dispatch('setNotification', {
              type: 'cross-outlined',
              text: errorMessage,
            })
            reject(error)
          })
      })
    },
    deletePanels(cuid, panelIds, organizationId) {
      return new Promise((resolve, reject) => {
        this.panelService
          .deletePanels(cuid, panelIds, organizationId)
          .then(() => {
            resolve()
          })
          .catch(error => {
            console.log(error)
            if (error.response && error.response.status === 404) {
              // If panels not found, consider them deleted
              resolve()
            } else {
              reject(error)
            }
          })
      })
    },
    generatePanelLink(cuid, panel_id, device_id, organization_id) {
      return new Promise((resolve, reject) => {
        this.panelService
          .generatePanelAccessLink(cuid, panel_id, device_id, organization_id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    generateDeviceAccessLink() {
      return new Promise((resolve, reject) => {
        this.panelService
          .generateDeviceAccessLink()
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    loadManufacturers() {
      return new Promise((resolve, reject) => {
        this.panelService
          .getManufacturers()
          .then(response => {
            this.$store.dispatch('setManufacturers', response.data || [])
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    loadControlledDeviceTypes() {
      return new Promise((resolve, reject) => {
        this.panelService
          .getControlledDeviceTypes()
          .then(response => {
            this.$store.dispatch(
              'setControlledDeviceTypes',
              response.data || []
            )
            resolve(response)
          })
          .catch(error => {
            if (error.response && error.response.data) {
              this.$store.dispatch('setNotification', {
                text:
                  error.response.data.message || 'Error loading device types',
              })
            }
            reject(error)
          })
      })
    },
    getVerifiedColumnContent(id, label) {
      let content = { id: id }

      if (label) {
        content['label-true'] = label
      } else {
        content['label-false'] = label
      }

      return content
    },
  },
  computed: {
    intercomList() {
      return this.$store.getters.intercoms
    },
    intercomsMeta() {
      return this.$store.getters.intercomsMeta
    },
    serverList() {
      return this.$store.getters.servers
    },
    serverListFilter() {
      return this.$store.getters.serversFilter
    },
    serversMeta() {
      return this.$store.getters.serversMeta
    },
    serverHealthChecks() {
      return this.$store.getters.serverHealthChecks
    },
    propertyList() {
      return this.$store.getters.properties
    },
    contactList() {
      return this.$store.getters.contacts
    },
    contactsMeta() {
      return this.$store.getters.contactsMeta
    },
    panelsList() {
      return this.$store.getters.panels
    },
    panelsMeta() {
      return this.$store.getters.panelsMeta
    },
    propertiesWithContactsList() {
      return this.$store.getters.propertiesWithContacts
    },
    serverListOptions() {
      let serverListOptions = []

      this.serverListFilter.forEach(server => {
        serverListOptions.push({
          id: server.suid,
          label: server.host,
        })
      })

      return serverListOptions
    },
    propertyListOptions() {
      let propertyListOptions = []

      this.propertyList.forEach(property => {
        propertyListOptions.push({
          id: property.puid,
          label: property.address,
        })
      })

      return propertyListOptions
    },
    currentOrganizationId() {
      return this.$store.getters.currentOrganizationId
    },
  },
}
